import React from "react"

import { s } from "../../../../../utilities/common"

export const PlayIcon = () => (
  <svg
    width={s("40")}
    height={s("40")}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.542 31.583C14.792 32.0557 14.042 32.0837 13.292 31.667C12.542 31.2503 12.167 30.6113 12.167 29.75V10.083C12.167 9.22233 12.542 8.58367 13.292 8.167C14.042 7.75033 14.792 7.778 15.542 8.25L30.917 18.083C31.611 18.5277 31.958 19.146 31.958 19.938C31.958 20.7293 31.611 21.3333 30.917 21.75L15.542 31.583Z"
      fill="#FFED00"
    />
  </svg>
)
